import CallbackCard from './CallbackCard';

const CallbacksList = ({
  callbacks,
  savingId,
  deletingId,
  onUpdate,
  onDelete,
  onSave,
  onAddHeader,
  onUpdateHeader,
  onRemoveHeader
}) => (
  <div className='space-y-6'>
    {callbacks.map((c, idx) => (
      <CallbackCard
        key={c.localId}
        callback={c}
        index={idx}
        savingId={savingId}
        deletingId={deletingId}
        onUpdate={onUpdate}
        onDelete={onDelete}
        onSave={onSave}
        onAddHeader={onAddHeader}
        onUpdateHeader={onUpdateHeader}
        onRemoveHeader={onRemoveHeader}
      />
    ))}
    {callbacks.length === 0 && (
      <p className='text-gray-500 text-sm'>No enterprise callbacks for this user. Use &quot;Add new callback&quot; to create one.</p>
    )}
  </div>
);

export default CallbacksList;
